import { NgModule } from '@angular/core';
import { Routes, RouterModule, LoadChildren } from '@angular/router';
import { NotFoundComponent, MainContainerComponent, EntryPageComponent, EmptyContainerComponent, BaseRoutes } from '@nts/std';
import { EnvironmentConfiguration } from '@nts/std/src/lib/environments';
import { environment } from 'src/environments/environment';

// `export`ing these function fixed the error "Error: Cannot read property 'loadChildren' of null"
export function getEntityRoutes(title: string, entityName: string, loadChildren: LoadChildren) {
  return [
    {
      path: `manage/${entityName}`,
      data: {
        title
      },
      loadChildren,
    }
  ];
}

export function getDefaultRoutes(title: string, environment: EnvironmentConfiguration, debugMode = false) {
  return [
    debugMode ?
      {
        path: '',
        component: EntryPageComponent,
        data: {
          title: environment.appTitle
        }
      } : {}
  ];
}

const title = environment ? environment.appTitle : 'Application Title';


const routes: Routes = [
  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...getEntityRoutes(
        title,
        'modulefeatures',
        () => import('./module-features/module-features.module').then(m => m.ModuleFeaturesModule)
      ),
      ...getEntityRoutes(
        title,
        'salesconfigurator',
        () => import('./sales-configurator/sales-configurator.module').then(m => m.SalesConfiguratorModule)
      ),
      ...getEntityRoutes(
        title,
        'salescharge',
        () => import('./sales-charge/sales-charge.module').then(m => m.SalesChargeModule)
      ),
      ...getEntityRoutes(
        title,
        'storeconfigurator',
        () => import('./store-configurator/store-configurator.module').then(m => m.StoreConfiguratorModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardbacmanager',
        () => import('./subscription-wizard-bac-manager/subscription-wizard-bac-manager.module').then(m => m.SubscriptionWizardBacManagerModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardbac',
        () => import('./subscription-wizard-bac/subscription-wizard-bac.module').then(m => m.SubscriptionWizardBacModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizarddssmanager',
        () => import('./subscription-wizard-dss-manager/subscription-wizard-dss-manager.module').then(m => m.SubscriptionWizardDssManagerModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizarddss',
        () => import('./subscription-wizard-dss/subscription-wizard-dss.module').then(m => m.SubscriptionWizardDssModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardexperiencemanager',
        () => import('./subscription-wizard-experience-manager/subscription-wizard-experience-manager.module').then(m => m.SubscriptionWizardExperienceManagerModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardexperience',
        () => import('./subscription-wizard-experience/subscription-wizard-experience.module').then(m => m.SubscriptionWizardExperienceModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardweamanager',
        () => import('./subscription-wizard-wea-manager/subscription-wizard-wea-manager.module').then(m => m.SubscriptionWizardWeaManagerModule)
      ),
      ...getEntityRoutes(
        title,
        'subscriptionwizardwea',
        () => import('./subscription-wizard-wea/subscription-wizard-wea.module').then(m => m.SubscriptionWizardWeaModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...getEntityRoutes(
        title,
        'subscriptionwizard',
        () => import('./subscription-wizard/subscription-wizard.module').then(m => m.SubscriptionWizardModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ],
    () => import('@nts/std').then(mod => mod.EmptyContainerComponent),
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
